"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _semanticUiReact = require("semantic-ui-react");

var _react = _interopRequireDefault(require("react"));

var _default = function _default(_ref) {
  var linksAs = _ref.linksAs,
      item = _ref.item;
  var pageTitle = item.pageTitle,
      emphasis = item.emphasis,
      inverted = item.inverted;
  var itemText = emphasis ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    inverted: inverted
  }, pageTitle) : pageTitle;
  return linksAs === 'text' ? /*#__PURE__*/_react["default"].createElement("span", null, itemText) : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, null, itemText);
};

exports["default"] = _default;